import css from 'styled-jsx/css';

const styles = css.global`#sec-blog-content {
  display: flex;
  flex-direction: column-reverse;
  align-items: flex-start;
  justify-content: space-between;
}

#sec-blog-cta,
#sec-blog-cta-mobile {
  padding: 15px;
  padding-top: 40px;
  width: 100%;
  box-sizing: border-box;
}

#sec-blog-cta {
  position: static;
  padding-bottom: 0;
}

#sec-blog-cta-mobile {
  padding-top: 0;
  padding-bottom: 0;
  position: sticky;
  top: 80px;
}

#sec-blog-go-back {
  margin-top: 24px;
}

#sec-blog-go-back a {
  color: #cc0000;
  font-family: 'SantanderText';
  text-decoration: underline;
  cursor: pointer;
  font-size: 18px;
}

@media (min-width: 992px) {
  #sec-blog-content {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
  }

  #sec-blog-cta {
    padding-top: 24px;
    padding-right: 30px;
    position: sticky;
    top: 140px;
    max-width: 400px;
  }

  #sec-blog-cta-mobile {
    display: none;
  }
}
`;

export default styles;